import {
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_SUCCEED,
  FETCH_NOTIFICATIONS_FAILED,
  ADD_NOTIFICATIONS,
  ADD_NOTIFICATIONS_SUCCEED,
  ADD_NOTIFICATIONS_FAILED,
  UPDATE_NOTIFICATIONS,
  UPDATE_NOTIFICATIONS_SUCCEED,
  UPDATE_NOTIFICATIONS_FAILED,
  DELETE_NOTIFICATIONS,
  DELETE_NOTIFICATIONS_SUCCEED,
  DELETE_NOTIFICATIONS_FAILED,
} from './action_types';

export default {
  fetchNotification: (params, callback) => ({
    type: FETCH_NOTIFICATIONS,
    params,
    callback,
  }),
  fetchNotificationSucceed: (data, totalCount, callback) => ({
    type: FETCH_NOTIFICATIONS_SUCCEED,
    params: {
      data,
      totalCount,
      callback,
    },
  }),
  fetchNotificationFailed: (err) => ({
    type: FETCH_NOTIFICATIONS_FAILED,
    err,
  }),

  addNotification: (params, callback) => ({
    type: ADD_NOTIFICATIONS,
    params,
    callback,
  }),
  addNotificationSucceed: (data, callback) => ({
    type: ADD_NOTIFICATIONS_SUCCEED,
    params: {
      data,
      callback,
    },
  }),
  addNotificationFailed: (err) => ({
    type: ADD_NOTIFICATIONS_FAILED,
    err,
  }),

  updateNotification: (params, callback) => ({
    type: UPDATE_NOTIFICATIONS,
    params,
    callback,
  }),
  updateNotificationSucceed: (data, callback) => ({
    type: UPDATE_NOTIFICATIONS_SUCCEED,
    params: {
      data,
      callback,
    },
  }),
  updateNotificationFailed: (err) => ({
    type: UPDATE_NOTIFICATIONS_FAILED,
    err,
  }),

  deleteNotification: (params, callback) => ({
    type: DELETE_NOTIFICATIONS,
    params,
    callback,
  }),
  deleteNotificationSucceed: (data, callback) => ({
    type: DELETE_NOTIFICATIONS_SUCCEED,
    params: {
      data,
      callback,
    },
  }),
  deleteNotificationFailed: (err) => ({
    type: DELETE_NOTIFICATIONS_FAILED,
    err,
  }),
};
